export enum ResourceTypeEnum {
  OVERFLOW = 'OVERFLOW',
  OVERBOOKING = 'OVERBOOKING'
}
